<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-i">Acknowledgements</span></p>
<p class="co">As always my thanks go out to the various people who work behind the scenes, but seldom get their name up in lights. To everyone at the Blake Friedmann Literary Agency, including my wonderful agent Carole Blake, who is now an author in her own right after the publication of her book <span class="epub-i">From Pitch to Publication</span> on how to go about selling your manuscript.</p>
<p class="tx">I would like to thank everyone at Little, Brown, especially my editor Barbara Boote who always delights me by telling me which bits of the novel made her cry! Also to my desk and copy editors, Emma Gibb and Richenda Todd for dotting the I’s and crossing the T’s – not to say sorting out the muddle of dates and seasons that several drafts of <span class="epub-i">Lords</span> had left in their wake.</p>
<p class="tx">Also I would like to express my gratitude to my family, for putting up with me (although it cuts both ways as I have to put up with them!). To the members of <span class="epub-i">Regia Anglorum,</span> Conquest and <span class="epub-i">Conroi de Burm</span> for sharing their knowledge and giving me inspiration; the members of Nottingham Writers’ Contact for the laughs and support (who can forget Annabel’s Antics?); and to the members of <span class="epub-u">Medievalreader@egroups.com</span> and <span class="epub-u">Medievalenthusiasts@egroups.com</span> for chats on my favourite subject!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?1f859815